import {Component, Input, OnInit} from "@angular/core";
@Component({
    selector: "text-post",
    templateUrl: "./text-post.template.html",
    styleUrls: ["./text-post.style.scss"]
})

export class TextPost{
    @Input() document : any;
    constructor(){

    }

    ngOnInit(){

    }
}


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/text-post/text-post.component.ts